import { render, staticRenderFns } from "./XinZiChanFuZhai.vue?vue&type=template&id=1f43f000&scoped=true"
import script from "./XinZiChanFuZhai.vue?vue&type=script&lang=js"
export * from "./XinZiChanFuZhai.vue?vue&type=script&lang=js"
import style0 from "./XinZiChanFuZhai.vue?vue&type=style&index=0&id=1f43f000&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f43f000",
  null
  
)

export default component.exports